
const setUsuarioLogado = (context, usuario) => {
  context.commit('SET_USUARIO_LOGADO', usuario)
}

export {
  setUsuarioLogado
}



// WEBPACK FOOTER //
// ./src/store/usuario/actions.js